module.exports = {
  purge: ["./src/**/*.vue", "./src/**/*.js"],
  theme: {
    extend: {
      spacing: {
        "filter-pad-desk": "0.813rem",
        "filter-pad-mob": "0.5rem",
        "filter-gap-desk": "1.25rem",
        "filter-gap-mob": "0.75rem"
      },
      zIndex: {
        "neg-1": -1
      },
      minHeight: {
        "32": "8rem"
      }
    },
    screens: {
      sm: "640px", // => @media (min-width: 640px) { ... }
      md: "768px", // => @media (min-width: 768px) { ... }
      lg: "1024px", // => @media (min-width: 1024px) { ... }
      xl: "1280px" // => @media (min-width: 1280px) { ... }
    },
    maxWidth: {
      modal: "42rem",
      "screen-sm": "640px",
      "screen-md": "768px",
      "screen-lg": "1024px",
      "screen-xl": "1280px"
    },
    colors: {
      avo: "#d8d97e",
      egg: "#f7f4e3",
      pink: "#ffa3a1",
      white: "#ffffff",
      teal: "#155457",
      blue: "#1474a8",
      powder: "#88a3aa",
      rust: "#d67e0b",
      red: "#cf412e",
      moss: "#4e4f3e",
      yellow: "#ffd438",
      stone: "#ccc6b7",
      brown: "#2f292b",
      black: "#000000"
    },
    fontFamily: {
      body: ["fann-grotesque-regular-pro", "serif"],
      empahsis: ["fann-grotesque-italic-pro", "serif"],
      title: ["fann-grotesque-medium-pro", "sans-serif"]
    },
    opacity: {
      "0": "0",
      "30": ".3",
      "100": "1"
    },
    fontSize: {
      "1-desk": "0.75rem", // 12px
      "2-desk": "0.875rem", // 14px
      "3-desk": "1.063rem", // 17px
      "4-desk": "1.563rem", // 25px
      "5-desk": "1.875rem", // 30px
      "6-desk": "2.5rem", // 40px
      "1-mob": "0.563rem", // 9px
      "2-mob": "0.75rem", // 12px
      "3-mob": "0.813rem", // 13px
      "4-mob": "1.063rem", // 17px
      "5-mob": "1.438rem", // 23px
      "6-mob": "2.188rem" // 35px
    },
    borderRadius: {
      none: "0",
      tight: "0.75rem",
      loose: "1rem",
      full: "9999px"
    },
    boxShadow: {
      modal: "6px 6px 10px 0px rgba(0,0,0,0.4)"
    }
  },
  variants: {},
  plugins: []
};
